<template>
  <v-row
    class="justify-center align-center Login-Section"
    style="min-height: 100vh"
  >
    <v-col cols="12" sm="10" md="8" lg="6" xl="4">
      <v-form ref="signUpForm" v-model="isValid">
        <v-card elevation="12" class="pa-6 rounded-xl">
          <v-card-title class="d-flex justify-center mb-5">
            <img
              class="Brand-Logo"
              alt="Brand Logo"
              src="@/assets/images/brand-logo.png"
              height="80"
            />
          </v-card-title>

          <v-card-text>
            <v-row dense>
              <!-- Company Name -->
              <v-col cols="12">
                <InputField
                  type="text"
                  hide-details="auto"
                  label="Company Name *"
                  required
                  :rules="[(val) => !!val || 'Company Name is Required!']"
                  v-model="companyDetails.company_name"
                />
              </v-col>

              <!-- Contact Person & Switch -->
              <v-col cols="12">
                <InputField
                  type="text"
                  hide-details="auto"
                  label="Contact Person *"
                  required
                  :rules="[(val) => !!val || 'Contact Person is Required!']"
                  v-model="companyDetails.contact_person"
                />
              </v-col>
              <v-col cols="9" class="mt-2 mb-0">
                <MultiSelect
                  hide-details="auto"
                  label="Mode of Communication*"
                  required
                  :items="modeList"
                  itemText="display_name"
                  itemValue="value"
                  :rules="[
                    (val) => !!val || 'Mode of Communications is Required!',
                  ]"
                  v-model="companyDetails.mode_of_communication"
                />
              </v-col>
              <v-col cols="3" class="pt-0">
                <v-switch
                  v-model="companyDetails.is_existing_customer"
                  inset
                  color="primary"
                  label="Existing customer"
                />
              </v-col>

              <!-- Designation -->
              <v-col cols="12">
                <InputField
                  type="text"
                  hide-details="auto"
                  label="Designation *"
                  required
                  :rules="[(val) => !!val || 'Designation is Required!']"
                  v-model="companyDetails.designation"
                />
              </v-col>

              <!-- Company Type -->
              <v-col cols="12">
                <MultiSelect
                  hide-details="auto"
                  label="Company Type *"
                  required
                  :items="compnayTypeList"
                  itemText="user_type"
                  itemValue="value"
                  :rules="[(val) => !!val || 'Company Type is Required!']"
                  v-model="companyDetails.company_type"
                />
              </v-col>

              <!-- Email -->
              <v-col cols="12">
                <InputField
                  type="text"
                  hide-details="auto"
                  label="Email *"
                  required
                  :rules="[
                    (val) => !!val || 'Email is Required!',
                    (val) => /.+@.+\..+/.test(val) || 'Email must be valid',
                  ]"
                  v-model="companyDetails.company_email"
                />
              </v-col>

              <!-- Phone Code & Number -->
              <v-col cols="12" sm="4">
                <MultiSelect
                  hide-details="auto"
                  label="Phone Code *"
                  required
                  :items="allPhoneCodeList"
                  itemText="phone_code"
                  itemValue="phone_code"
                  :rules="[(val) => !!val || 'Phone Code is Required!']"
                  v-model="companyDetails.phone_code"
                />
              </v-col>
              <v-col cols="12" sm="8">
                <InputField
                  type="number"
                  hide-details="auto"
                  label="Contact Number *"
                  required
                  :rules="[(val) => !!val || 'Contact Number is Required!']"
                  v-model="companyDetails.company_contact_number"
                />
              </v-col>

              <!-- Address -->
              <v-col cols="12">
                <InputField
                  type="text"
                  hide-details="auto"
                  label="Address Line 1 *"
                  required
                  :rules="[(val) => !!val || 'Address Line 1 is Required!']"
                  v-model="companyDetails.address_line_1"
                />
              </v-col>

              <!-- Service Type -->
              <v-col cols="12">
                <MultiSelect
                  hide-details="auto"
                  label="Service Type *"
                  required
                  :items="serviceTypeList"
                  itemText="display_name"
                  itemValue="value"
                  :rules="[(val) => !!val || 'Service Type is Required!']"
                  v-model="companyDetails.service_type"
                />
              </v-col>
              <!-- Upload Documents Panel -->
              <v-col cols="12" class="mt-2">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span class="font-weight-bold">
                        Company Request Documents</span
                      >
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row class="my-0">
                        <v-col cols="5" class="Form-Columns">
                          <InputField
                            type="text"
                            label="Document Name *"
                            required
                            hide-details="auto"
                            v-model="uploadDocumentType"
                          />
                        </v-col>

                        <v-col cols="5">
                          <v-file-input
                            label="Document *"
                            accept="image/x-png,image/jpg,image/jpeg,application/pdf"
                            :rules="[
                              (file) =>
                                !file ||
                                file.size < 2e6 ||
                                'File size should be less than 2 MB!',
                            ]"
                            outlined
                            dense
                            prepend-icon=""
                            prepend-inner-icon="mdi-paperclip"
                            hide-details="auto"
                            v-model="uploadFiles"
                            @change="checkFileFormat($event)"
                          />
                        </v-col>
                        <v-col cols="2" class="d-flex justify-end">
                          <v-btn color="primary" depressed @click="addDoc()">
                            Add
                          </v-btn>
                        </v-col>

                        <v-col
                          v-show="documentList && documentList.length"
                          cols="12"
                          class="Form-Columns-Dense"
                        >
                          <span
                            class="text-h6 font-weight-regular mb-2 d-block"
                          >
                            New Upload
                          </span>

                          <v-card elevation="1" outlined class="pa-3">
                            <v-card-text class="Form-Columns-Dense">
                              <!-- 📄 Header Row -->
                              <v-row
                                class="ma-0 font-weight-bold text--secondary mb-2"
                              >
                                <v-col cols="12" lg="6" class="py-1"
                                  >File Name / Link</v-col
                                >
                                <v-col cols="6" lg="3" class="py-1"
                                  >Document Name</v-col
                                >
                                <v-col cols="6" lg="3" class="py-1 text-right"
                                  >Action</v-col
                                >
                              </v-row>

                              <!-- 📂 Document Rows -->
                              <v-row
                                class="ma-0 py-2"
                                v-for="(data, i) in documentList"
                                :key="i"
                                align="center"
                              >
                                <v-col
                                  cols="12"
                                  lg="6"
                                  class="py-1 d-flex align-center"
                                >
                                  <v-icon
                                    left
                                    color="blue lighten-1"
                                    class="mr-2"
                                  >
                                    {{
                                      data.file.type.includes("pdf")
                                        ? "mdi-file-pdf"
                                        : "mdi-file-image"
                                    }}
                                  </v-icon>
                                  <a
                                    :href="generateUrl(data.file)"
                                    target="_blank"
                                    class="file-link"
                                  >
                                    <span class="font-weight-medium">{{
                                      data.file.name
                                    }}</span>
                                  </a>
                                </v-col>

                                <v-col cols="6" lg="3" class="py-1">
                                  <v-chip
                                    small
                                    color="primary"
                                    text-color="white"
                                  >
                                    {{ data.document_name }}
                                  </v-chip>
                                </v-col>

                                <v-col cols="6" lg="3" class="text-right py-1">
                                  <v-tooltip top>
                                    <template #activator="{ on, attrs }">
                                      <v-icon
                                        small
                                        color="red darken-1"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="removeFile(i)"
                                        class="cursor-pointer"
                                      >
                                        mdi-close
                                      </v-icon>
                                    </template>
                                    <span>Remove File</span>
                                  </v-tooltip>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Actions -->
          <v-card-actions class="mt-4">
            <v-row dense class="w-100">
              <v-col cols="12" class="d-flex justify-center">
                <v-btn
                  type="submit"
                  color="primary"
                  depressed
                  :disabled="!isValid"
                  @click="submitForm"
                  size="large"
                  class="px-10"
                >
                  Get OTP
                </v-btn>
              </v-col>
              <v-col cols="12" class="d-flex justify-center">
                <v-btn
                  @click="goToLogin"
                  type="button"
                  text
                  color="primary"
                  class="text-decoration-underline"
                >
                  Go to Login
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import { encryptText } from "@/utils/functions";
import {
  serviceTypeListCategory,
  statusCategory,
  modeTypeList,
} from "@/utils/choices";
export default {
  components: { InputField, MultiSelect },
  layout: "sigup",
  data() {
    return {
      formErrors: {
        uploadDocumentType: null,
        uploadFiles: null,
      },
      companyDetails: {},
      allPhoneCodeList: [],
      documentPanel: [],
      documentList: [],
      uploadFiles: null,
      uploadDocumentType: null,
      compnayTypeList: ["Customer", "Transporter"],
      btnLoading: false,
      password: "Password",
      serviceTypeList: serviceTypeListCategory,
      statusCategoryList: statusCategory,
      modeList: modeTypeList,
      passwordEye: false,
      isValid: true,
      timer: 30,
      interval: null,
      disableOtpBtn: false,
    };
  },
  methods: {
    goToLogin() {
      this.$router.push("/app/login");
    },
    addDoc() {
      if (!this.uploadFiles) {
        this.$bus.$emit("showToastMessage", {
          message: "Please upload a document first!",
          color: "error",
        });
        return;
      }

      if (!this.checkFileFormat(this.uploadFiles)) {
        alert("This file format is not supported!");
        return;
      }

      this.documentList.push({
        file: this.uploadFiles,
        document_name: this.uploadDocumentType,
      });

      this.uploadFiles = null;
      this.uploadDocumentType = null;
    },
    // Method for documents
    uploadDocument(id = null) {
      return new Promise((resolve, reject) => {
        this.documentList.forEach((details, index) => {
          let payload = {
            id: null,
            data: null,
          };
          payload.id = id;
          let newForm = new FormData();
          newForm.append("document_name", details.document_name);
          newForm.append("document", details.file);

          payload.data = newForm;

          this.$api.unauthorisedApi
            .uploadCompanyRequestDocuments(payload)
            .then((response) => {
              resolve(response);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
    },
    checkFileFormat(event) {
      const name = event.name;
      const lastDot = name.lastIndexOf(".");
      const ext = name.substring(lastDot + 1);
      let allowed = /(\jpg|\jpeg|\pdf|\png)$/i;
      if (!allowed.exec(ext)) {
        this.$nextTick(() => {
          this.uploadFiles = null;
        });
        return false;
      } else {
        return true;
      }
    },
    removeFile(index) {
      this.documentList.splice(index, 1);
    },

    getFileData(fileInput) {
      if (fileInput) {
        if (this.checkFileFormat(fileInput)) {
          if (fileInput && this.uploadDocumentType) {
            this.documentList.push({
              file: fileInput,
              document_name: this.uploadDocumentType,
            });

            this.uploadDocumentType = null;
            this.uploadFiles = null;
          } else {
            this.uploadDocumentType = null;
            this.uploadFiles = null;

            this.$bus.$emit("showToastMessage", {
              message: "Select Document type first!",
              color: "error",
            });
            return false;
          }
        } else {
          alert("This file format is not supported!");
        }
      }
    },
    getSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    generateUrl(file) {
      return URL.createObjectURL(file);
    },
    reset() {
      this.companyDetails = {};
    },
    getPhoneCodeList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        ...params,
        limit: "all",
      };
      this.$api.unauthorisedApi
        .getCountryList(params)
        .then((res) => {
          this.allPhoneCodeList = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    async submitForm() {
      this.$bus.$emit("showLoader", true);
      let payload = {
        data: this.companyDetails,
      };
      await this.$api.unauthorisedApi
        .addCompanyRequest(payload.data)
        .then(async (res) => {
          if (this.documentList.length) {
            await this.uploadDocument(res.data.response_data.id);
          }

          this.$bus.$emit("showToastMessage", {
            message:
              "Check Your Mail You will get OTP  Request for verification",
            color: "success",
          });
          this.$router.push("/app/verification-otp");
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't Update!",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },
  },
  beforeMount() {
    this.getPhoneCodeList();
  },
};
</script>

<style scoped>
.Login-Section {
  height: 100vh;
}

.Login-Section .Brand-Logo {
  width: 250px;
}
</style>
